<template>
  <Dialog :open="open" @update:open="emit('update:open', $event)">
    <DialogScrollContent size="xl">
      <DialogHeader>
        <DialogTitle>
          {{ $t("Select item") }}
        </DialogTitle>
      </DialogHeader>
      <EquipmentIndex
        :base-filters="baseFilters"
        :available-filters="availableFilters"
        :product-metafields="productMetafields"
        :equipment-metafields="equipmentMetafields"
      >
        <template v-slot:default="{ equipments }">
          <EquipmentsClickable
            v-if="equipments"
            :equipments="equipments"
            :with-availability="withAvailability"
            @equipment-selected="emit('select', $event)"
            @availability-requested="inspected = $event"
          >
          </EquipmentsClickable>
        </template>
      </EquipmentIndex>
    </DialogScrollContent>
  </Dialog>

  <EquipmentAvailabilityDialog
    :open="inspected !== null"
    :equipment="inspected"
    :timezone="timezone"
    @update:open="inspected = $event ? inspected : null"
  />
</template>

<script setup>
import { ref } from "vue";
import EquipmentIndex from "@/components/equipment/EquipmentIndex.vue";
import EquipmentsClickable from "@/components/equipment/EquipmentsClickable.vue";
import EquipmentAvailabilityDialog from "@/components/booking/dialogs/EquipmentAvailabilityDialog.vue";
import { Dialog, DialogScrollContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

defineProps({
  open: {
    type: Boolean,
    default: false
  },
  baseFilters: {
    type: Object,
    default: () => ({})
  },
  availableFilters: {
    type: Array,
    default: () => []
  },
  productMetafields: {
    type: Array,
    default: () => []
  },
  equipmentMetafields: {
    type: Array,
    default: () => []
  },
  /** Lets the user inspect when an item is taken, without leaving the list. */
  withAvailability: {
    type: Boolean,
    default: false
  },
  timezone: {
    type: String,
    default: null
  }
});

const emit = defineEmits(["update:open", "select"]);

/** The item whose availability is on screen, if any. */
const inspected = ref(null);
</script>
